import React from 'react';
import { Card, Badge } from './ui';
import { CheckCircle, Book, BookOpen, BookMarked, Library, Notebook, BookType, Gift, Sparkles } from 'lucide-react';
export function Product() {
  const tomos = [{
    icon: <Book className="w-8 h-8 text-brand-400" data-id="element-94" />,
    color: 'bg-brand-500/10 border-brand-500/20',
    title: 'TOMO 1 — Reiki de Emergencia',
    subtitle: '(Ansiedad y Pánico)',
    desc: 'Volvé a recuperar la calma cuando sentís que todo te supera.'
  }, {
    icon: <BookOpen className="w-8 h-8 text-brand-300" data-id="element-95" />,
    color: 'bg-brand-500/10 border-brand-500/20',
    title: 'TOMO 2 — Reiki para Dormir',
    subtitle: '(Insomnio)',
    desc: 'Prepará cuerpo y mente para descansar profundamente.'
  }, {
    icon: <BookMarked className="w-8 h-8 text-amber-400" data-id="element-96" />,
    color: 'bg-amber-500/10 border-amber-500/20',
    title: 'TOMO 3 — Escudo Energético',
    subtitle: '(Protección)',
    desc: 'Aprendé a proteger tu energía y dejar de absorber cargas externas.'
  }, {
    icon: <Library className="w-8 h-8 text-brand-400" data-id="element-97" />,
    color: 'bg-brand-500/10 border-brand-500/20',
    title: 'TOMO 4 — Reiki de la Abundancia',
    subtitle: '(Dinero)',
    desc: 'Trabajá las creencias que bloquean tu relación con la prosperidad.'
  }, {
    icon: <Notebook className="w-8 h-8 text-brand-300" data-id="element-98" />,
    color: 'bg-brand-500/10 border-brand-500/20',
    title: 'TOMO 5 — Reiki para Corazones Rotos',
    subtitle: '(Rupturas)',
    desc: 'Un protocolo para sanar emocionalmente y volver a abrirte al amor.'
  }, {
    icon: <BookType className="w-8 h-8 text-amber-400" data-id="element-99" />,
    color: 'bg-amber-500/10 border-amber-500/20',
    title: 'TOMO 6 — Reiki del Renacer',
    subtitle: '(Autoestima)',
    desc: 'Reconectá con tu valor personal y fortalecé tu amor propio.'
  }];
  return <section className="py-12 px-4 bg-slate-900/30 pt-[4px] pb-[4px]" data-id="element-100">
      <div className="max-w-5xl mx-auto" data-id="element-101">
        <div className="text-center mb-10" data-id="element-102">
          <Badge variant="success" className="mb-4" data-id="element-103">
            PUNTO DIGITAL™ — MEGAPACK REIKI
          </Badge>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-104">
            6 Protocolos + 5 Bonos
          </h2>
          <p className="text-xl text-slate-400" data-id="element-105">
            Todo para empezar tu transformación energética.
          </p>
          <div className="flex flex-wrap justify-center gap-2 mt-6 text-sm font-medium text-brand-400" data-id="element-106">
            <span data-id="element-107">Calma</span> <span className="text-slate-600" data-id="element-108">→</span>
            <span data-id="element-109">Descanso</span> <span className="text-slate-600" data-id="element-110">→</span>
            <span data-id="element-111">Protección</span> <span className="text-slate-600" data-id="element-112">→</span>
            <span data-id="element-113">Abundancia</span> <span className="text-slate-600" data-id="element-114">→</span>
            <span data-id="element-115">Sanación</span> <span className="text-slate-600" data-id="element-116">→</span>
            <span data-id="element-117">Renacer</span>
          </div>
        </div>

        <div className="mb-10" data-id="element-118">
          <h3 className="text-xl font-bold text-white mb-5 flex items-center gap-3" data-id="element-119">
            <Sparkles className="w-8 h-8 text-brand-400" data-id="element-120" /> 6 PROTOCOLOS
            COMPLETOS
          </h3>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-121">
            {tomos.map((tomo, i) => <Card key={i} className={`border ${tomo.color}`} data-id="element-122">
                <div className="flex items-start gap-4" data-id="element-123">
                  <div className="p-3 bg-slate-900 rounded-xl shrink-0" data-id="element-124">
                    {tomo.icon}
                  </div>
                  <div data-id="element-125">
                    <h4 className="font-bold text-white text-lg mb-1" data-id="element-126">
                      {tomo.title}
                    </h4>
                    <p className="text-brand-400 text-sm font-medium mb-3" data-id="element-127">
                      {tomo.subtitle}
                    </p>
                    <p className="text-slate-400 text-sm leading-relaxed" data-id="element-128">
                      {tomo.desc}
                    </p>
                  </div>
                </div>
              </Card>)}
          </div>
        </div>

        <Card className="bg-slate-900" data-id="element-129">
          <h4 className="font-bold text-xl text-white mb-6" data-id="element-130">
            Cada protocolo incluye:
          </h4>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-131">
            {['Paso a paso.', 'Prácticas guiadas.', 'Ejercicios.', 'Aplicación inmediata.', 'Consejos prácticos.'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-132">
                <CheckCircle className="w-5 h-5 text-brand-400 shrink-0 mt-0.5" data-id="element-133" />
                <span className="text-slate-300" data-id="element-134">{item}</span>
              </div>)}
          </div>
        </Card>
      </div>
    </section>;
}
export function Bonuses() {
  const bonuses = [{
    title: 'Tarjetero de Protocolos Express',
    desc: 'Recordatorios prácticos para acompañarte cuando necesites una pausa de calma.',
    value: '$8.000'
  }, {
    title: 'Calendario de Aplicación de 21 Días',
    desc: 'Una guía diaria y clara para convertir tu práctica en un hábito de bienestar.',
    value: '$8.000'
  }, {
    title: 'Guiones de Meditación para Leer',
    desc: 'Textos simples para guiar tus momentos de presencia y conexión interior.',
    value: '$9.000'
  }, {
    title: 'Test de Diagnóstico Energético',
    desc: 'Una herramienta para reconocer qué aspecto de tu energía necesita atención.',
    value: '$8.000'
  }, {
    title: 'Guía Rápida de Autotratamiento',
    desc: 'Una referencia accesible para volver a vos en cualquier momento del día.',
    value: '$9.000'
  }];
  return <section className="py-12 px-4" data-id="element-135">
      <div className="max-w-5xl mx-auto" data-id="element-136">
        <div className="text-center mb-8" data-id="element-137">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-3 flex items-center justify-center gap-3" data-id="element-138">
            <Gift className="w-9 h-9 text-brand-400" data-id="element-139" />5 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-xl text-brand-400 font-bold uppercase tracking-widest" data-id="element-140">
            Siempre incluidos
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-6 gap-4 mb-8" data-id="element-141">
          {bonuses.map((bono, i) => <Card key={i} className={`relative overflow-hidden group hover:border-brand-500/50 transition-colors lg:col-span-2 ${i === 3 ? 'lg:col-start-2' : ''}`} data-id="element-142">
              <div className="absolute top-0 right-0 bg-brand-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-143">
                BONO {i + 1}
              </div>
              <h4 className="font-bold text-white text-lg mb-3 pr-12 mt-2" data-id="element-144">
                {bono.title}
              </h4>
              <p className="text-slate-400 text-sm mb-6" data-id="element-145">{bono.desc}</p>
              <div className="mt-auto pt-4 border-t border-slate-800 flex justify-between items-center" data-id="element-146">
                <span className="line-through text-slate-500 text-sm" data-id="element-147">
                  Valor {bono.value}
                </span>
                <span className="text-brand-400 font-bold" data-id="element-148">GRATIS</span>
              </div>
            </Card>)}
        </div>

        <div className="bg-gradient-to-r from-brand-900/50 to-brand-800/50 border border-brand-500/30 rounded-2xl p-8 text-center max-w-2xl mx-auto" data-id="element-149">
          <p className="text-slate-300 mb-2" data-id="element-150">Valor total bonos</p>
          <p className="text-4xl font-black text-white mb-2 line-through decoration-red-500/50" data-id="element-151">
            $51.000
          </p>
          <p className="text-2xl font-bold text-brand-400" data-id="element-152">
            → GRATIS con tu Megapack Reiki
          </p>
        </div>
      </div>
    </section>;
}